import { faComment, faHouse, faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';
import styled from 'styled-components6';
import { Body1, Subtitle1 } from 'rwl-ui';
import { VerticalDivider } from '../../components';
import { useBreakpoint } from '../../providers';
import { When } from 'react-if';

const StatsContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
`;

const Stat = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const StatCount = styled.div`
    display: flex;
    align-items: center;
`;

export const ServiceAreaStats = ({
    neighborhood,
}: {
    neighborhood: NeighborhoodServiceAreaInfo | undefined;
}) => {
    const { isBelowBreakpoint } = useBreakpoint();
    const hasReviews = !!neighborhood?.reviewCount;
    const jobCount = neighborhood?.jobCount || 0;
    const reviewCount = neighborhood?.reviewCount || 0;

    return (
        <StatsContainer
            style={{
                width: isBelowBreakpoint('sm') ? '100%' : '50%',
                justifyContent: hasReviews ? 'space-evenly' : 'flex-end',
            }}
        >
            <Stat>
                <StatCount>
                    <FontAwesomeIcon
                        style={{
                            marginRight: 'var(--rwl-spacing-sm)',
                        }}
                        icon={faHouse}
                        size="xs"
                    />
                    <Subtitle1>{jobCount}</Subtitle1>
                </StatCount>
                <Body1 style={{ color: 'var(--rwl-text-hint)' }}>
                    {jobCount === 1 ? 'Project' : 'Projects'}
                </Body1>
            </Stat>
            <When condition={hasReviews}>
                <VerticalDivider
                    style={{
                        height: '2.75em',
                        backgroundColor: 'var(--rwl-palette-gray-200)',
                    }}
                />
                <Stat>
                    <StatCount>
                        <FontAwesomeIcon
                            style={{
                                marginRight: 'var(--rwl-spacing-sm)',
                            }}
                            icon={faComment}
                            size="xs"
                        />
                        <Subtitle1>{reviewCount}</Subtitle1>
                    </StatCount>
                    <Body1 style={{ color: 'var(--rwl-text-hint)' }}>
                        {reviewCount === 1 ? 'Review' : 'Reviews'}
                    </Body1>
                </Stat>

                <VerticalDivider
                    style={{
                        height: '2.75em',
                        backgroundColor: 'var(--rwl-palette-gray-200)',
                    }}
                />
                <Stat>
                    <StatCount>
                        <FontAwesomeIcon
                            style={{
                                marginRight: 'var(--rwl-spacing-sm)',
                            }}
                            icon={faStar}
                            size="xs"
                        />
                        <Subtitle1>
                            {neighborhood?.averageRating?.toFixed(1) || 0}
                        </Subtitle1>
                    </StatCount>
                    <Body1 style={{ color: 'var(--rwl-text-hint)' }}>
                        Avg. rating
                    </Body1>
                </Stat>
            </When>
        </StatsContainer>
    );
};
